import { useEffect, useRef } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { ONE_DECK_MINUTES } from '@/lib/learnDeck'
import { useStartDeck } from './parts'

/**
 * The daily push opens here: it builds the day's deck and goes straight into it (or to Learn home when
 * nothing is lined up). It waits for the records to be read, so a cold start from the push is not empty.
 */
export const LearnTodayView = () => {
  const start = useStartDeck()
  const navigate = useNavigate()
  const ran = useRef(false)
  useEffect(() => {
    if (!start.ready || ran.current) return
    ran.current = true
    void start(ONE_DECK_MINUTES).then((ok) => navigate({ to: ok ? '/learn/deck' : '/learn', replace: true }))
  }, [start, navigate])
  return null
}
